<template>
  <div>
    <div class="heading">
      <div class="txt">
        Book a Flight
      </div>
    </div>

    <div class="body d-flex">
      <div class="left">
        <div class="field">
          <div class="label">PICK UP LOCATION</div>
          <location :value="pickup.title" @change="locationUpdate($event, 'pickup')" :extra="locationExtra" :error="error.pickup"></location>
        </div>

        <div class="field">
          <div class="label">DROP OFF LOCATION</div>
          <location :value="dropoff.title" @change="locationUpdate($event, 'dropoff')" :extra="locationExtra" :error="error.dropoff"></location>
        </div>

        <div class="field">
          <div class="d-flex align-center dep-label">
            <div class="label">DEPARTURE DATE</div>
            <select v-model="isReturnTrip" class="trip-type">
              <option :value="false">Single TRIP</option>
              <option :value="true">Return TRIP</option>
            </select>
          </div>
          <div class="d-flex">
            <div>
              <div class="sub-label">LEG 1</div>
              <datepicker :format="calendarFormat"
                :class="['datepicker inline', {'has-error':!!error.pickupDate}]"
                v-model="pickupDate" :disabled-picker="false"
                v-on:input="departureUpdate" :disabled="disabledDate"></datepicker>
              <div class="error-msg">{{error.pickupDate}}</div>
            </div>
            <div class="m-L-5">
              <div class="sub-label">LEG 2</div>
              <datepicker :format="calendarFormat"
                :class="['datepicker inline', {'has-error':!!error.pickupDateReturn}]"
                v-model="pickupDateReturn" :disabled-picker="!isReturnTrip"
                v-on:input="departureUpdate" :disabled="disabledDate"></datepicker>
              <div class="error-msg">{{error.pickupDateReturn}}</div>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="label">TRAVELLERS</div>
          <div class="d-flex">
            <div class="traveller">
              <div class="sub-label">Adult (13+)</div>
              <select>
                <option v-for="i in 10" :key="i" :value="i">{{i}}</option>
              </select>
            </div>
            <div class="traveller">
              <div class="sub-label">Children (2-12)</div>
              <select>
                <option v-for="i in 11" :key="i" :value="i - 1">{{i - 1}}</option>
              </select>
            </div>
            <div class="traveller">
              <div class="sub-label">Infants (below 2 years old)</div>
              <select>
                <option v-for="i in 11" :key="i" :value="i - 1">{{i - 1}}</option>
              </select>
            </div>
          </div>
        </div>

        <div @click="processFlights">SUBMIT</div>
      </div>
      <div class="right">
        wee
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
// import fdetails from './details'
import location from '../Partials/LocationInputNEW'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'flight-details',
  components: { location, datepicker },
  data () {
    return {
      locationExtra: {
        brandId: 10,
        disabled: false
      },
      today: moment(),
      error: {
        pickup: '',
        dropoff: '',
        pickupDate: '',
        pickupDateReturn: ''
      }
    }
  },
  computed: {
    airports () { return this.$store.state.airports.list },
    flights () { return this.$store.state.flights },
    create () { return this.flights.create },
    pickup () { return this.create.pickup },
    dropoff () { return this.create.dropoff },
    pickupDate: {
      get () { return this.create.pickupDate },
      set (x) { this.$store.commit('flights/setCreateData', {pickupDate: moment(x).format('MM/DD/YYYY')}) }
    },
    pickupDateReturn: {
      get () { return this.create.pickupDateReturn },
      set (x) { this.$store.commit('flights/setCreateData', {pickupDateReturn: moment(x).format('MM/DD/YYYY')}) }
    },
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    isReturnTrip: {
      get () { return this.create.isReturnTrip },
      set (x) { this.$store.commit('flights/setCreateData', {isReturnTrip: x}) }
    }
  },
  methods: {
    getAirportList () {
      let self = this
      if (self.airports.length) return

      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.get('/airports', {}, r => {
        let list = []
        if (!r.error) {
          r.list.forEach(function (data) {
            let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
            let add2 = data.addressLine2 === null ? '' : data.addressLine1
            let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
            if (data.enabled) {
              list.push({
                geofenceId: data.id,
                geofenceType: 'airport',
                address1: add1,
                address2: add2,
                city: data.city,
                lat: data.lat,
                lng: data.lng,
                state: data.state,
                title: data.name || title,
                zip: data.zipCode,
                description: data.description,
                airportCode: data.airportCode,
                locationId: data.locationId
              })
            }
          })
        }
        self.$store.commit('airports/setList', list)
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
      })
    },
    locationUpdate (val, field) {
      console.log('#locationUpdate', val, field)
      let tmp = {}
      tmp[field] = val
      this.$store.commit('flights/setCreateData', tmp)
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    departureUpdate (val) {
      console.log('#changeFlightDate', val)
    },
    processFlights () {
      this.error = {
        pickup: '',
        dropoff: '',
        pickupDate: '',
        pickupDateReturn: ''
      }
      let hasError = false
      let emptyField = 'This field cannot be empty.'
      if (!this.pickup.title) {
        hasError = true
        this.error.pickup = emptyField
      }
      if (!this.dropoff.title) {
        hasError = true
        this.error.dropoff = emptyField
      }
      if (!this.pickupDate) {
        hasError = true
        this.error.pickupDate = emptyField
      }
      if (this.isReturnTrip && !this.pickupDateReturn) {
        hasError = true
        this.error.pickupDateReturn = emptyField
      }
      let startDate = moment(this.pickupDate, 'MM/DD/YYYY')
      let endDate = moment(this.pickupDateReturn, 'MM/DD/YYYY')
      
      if (this.pickupDate && this.pickupDateReturn && startDate.diff(endDate, 'minutes') > 0) {
        this.error.pickupDate = 'End date must be later than start date.'
        this.error.pickupDateReturn = ' '
        hasError = true
      }

      if (hasError) {
        console.log('has error')
        return
      }
      console.log('PASSED')
    },
    getFlights () {

    }
  },
  watch: {
  },
  mounted () {
    let i = CONFIG.brands.findIndex(x => x.code === 'd2d')
    if (i > -1) this.locationExtra.brandId = CONFIG.brands[i].id

    this.getAirportList()

    // this.today = moment().add(this.d2dTimeBuffer, 'minutes')
    // this.selectedDate = moment().add(this.d2dTimeBuffer, 'minutes').format('MM/DD/YYYY')
    // this.returnDate = moment().add(this.d2dTimeBuffer, 'minutes').add(3, 'days').format('MM/DD/YYYY')
  }
}
</script>

<style lang="scss" scoped>
.heading{
  height: 50px;
  padding-left: 50px;

  .txt{
    line-height: 50px;
    padding-left: 20px;
    font-size: 21px;
    font-weight: 600;
  }
}

.body{
  background:#fafafa;
  width: 100%;
  min-height: calc(100vh - 50px);
  border-top: 2px solid #ccc;

  .left{
    width: 50%;
    padding: 15px 20px;
  }
  .right{
    width: 50%;
    border-left: 1px solid #ccc;
  }
}

.field{
  margin-bottom: 20px;

  .label{
    font-size: 13px;
    color: #888;
    line-height: 1;
    font-weight: 600;
  }
}
.dep-label{
  margin-bottom: 5px;
}
.trip-type{
  padding: 3px 5px;
  outline: none;
  width: auto;
  margin-left: 10px;
  font-size: 14px;
}
.sub-label{
  font-size: 12px;
  color: #777;
  margin: 2px 0 3px;
}
.traveller{
  width: 35%;
  max-width: 170px;
  margin-right: 10px;

  &:last-child{
    margin-right: 0;
  }
  select{
    padding:3px 5px;
  }
}
.error-msg{
  font-size: 11px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightCreate/index.vue